import React from 'react';
import styled from 'styled-components';

import { TRUNCATE_AT } from './DeviationResolutionCell';

const Issues = styled.span`
  white-space: pre-wrap;
  /* Wrap long text but never split inside a word (TUL-5517). */
  overflow-wrap: break-word;
`;

const Empty = styled.span`
  color: #9aa0a6;
`;

const extractLabel = (item) => {
  if (!item) {
    return null;
  }
  if (typeof item === 'string') {
    return item;
  }
  if (typeof item.value === 'string' && item.value.length > 0) {
    return item.value;
  }
  if (item.key) {
    return item.key;
  }
  return null;
};

const buildLabels = (improvements) => {
  if (!Array.isArray(improvements)) {
    return [];
  }
  return improvements.map(extractLabel).filter(Boolean);
};

const buildTitle = (labels, freeText) => {
  const full = labels.join(', ');
  if (freeText && full) {
    return `${full}\n\n${freeText}`;
  }
  return freeText || full;
};

const DeviationCell = ({ value }) => {
  if (!value) {
    return <Empty data-testid="deviation-empty">—</Empty>;
  }
  const labels = buildLabels(value.improvements);
  const freeText = value.freeText || '';

  if (labels.length === 0 && !freeText) {
    return <Empty data-testid="deviation-empty">—</Empty>;
  }

  const joined = labels.join(', ');
  const display = joined || freeText;
  const truncated = display.length > TRUNCATE_AT
    ? `${display.slice(0, TRUNCATE_AT).trimEnd()}…`
    : display;

  return (
    <Issues title={buildTitle(labels, freeText)} data-testid="deviation-issues">
      {truncated}
    </Issues>
  );
};

export default DeviationCell;
